import 'bootstrap/dist/js/bootstrap';
import "parsleyjs";

class Common {
  constructor() {
  }

  validate(form){
    this.formValidation = $(form).parsley({
      trigger: "focusout",
      errorClass: 'error',
      successClass: 'valid',
      errorsWrapper: '<div class="parsley-error-list"></div>',
      errorTemplate: '<label class="error"></label>',
      errorsContainer (field) {
        if(field.$element.hasClass('approve')){
          return $('.error-checkbox')
        }
        if(field.$element.hasClass('approve1')){
          return $('.error-checkbox1')
        }
        if(field.$element.hasClass('postcode')){
          return $('.postcode-error')
        }
        if(field.$element.hasClass('error-on-button')){
          return $(field.element.closest(".tab").querySelector(".error-box"))
        }
        return field.$element.parent()
      },
    })
  }

  validatePhone(){
    var CI = this
    window.Parsley.addValidator('validphone', {
      validateString: function(value){
        var xhr = $.ajax('https://go.webformsubmit.com/dukeleads/restapi/v1.2/validate/mobile?key=50f64816a3eda24ab9ecf6c265cae858&value='+$('.phone').val())
        return xhr.then(function(json) {
          var skipresponse = ["EC_ABSENT_SUBSCRIBER", "EC_ABSENT_SUBSCRIBER_SM", "EC_CALL_BARRED", "EC_SYSTEM_FAILURE","EC_SM_DF_memoryCapacityExceeded", "EC_NO_RESPONSE", "EC_NNR_noTranslationForThisSpecificAddress", "EC_NNR_MTPfailure", "EC_NNR_networkCongestion"]
          if (skipresponse.includes(json.response) && json.status == "Valid" ) {
            CI.isPhone = true
            return true
          }
          else if (json.status == "Valid") {
            CI.isPhone = true
            return true
          }else if(json.status == "Invalid"){
            return $.Deferred().reject("Please Enter Valid UK Phone Number");
          }else if(json.status == "Error"){
            CI.isPhone = true
            CI.sentryNotification("critical", json , "PHONE: Error Some network api is down")
            return true
          }else{
             CI.sentryNotification("info", json , "PHONE: Error other than the ApiDown")
            CI.isPhone = true
            return true
          }
        }).catch(function(e) {
          if (e == "Please Enter Valid UK Phone Number") {
            return $.Deferred().reject("Please Enter Valid UK Phone Number")
          }else{
            CI.isPhone = true
            CI.sentryNotification("critical", e , "PHONE: Error API Down")
            return true
          }
        });
      },
      messages: {
         en: 'Please Enter Valid UK Phone Number',
      }
    });
  }

  showTab(n) {
    var CI = this
    var tab = $('.tab');
    $(tab[CI.currentTab]).show();
    if (n == 0 || n == tab.length-1) {
      $('#prevBtn').hide();
    } else {
      $('#prevBtn').show();
    }
    if (n == (tab.length - 2)) {
      $("#nextBtn").html("Submit");
    } else if(n == (tab.length - 1)) {
      $("#nextBtn").hide();
    }
    else{
      $("#nextBtn").html("Continue");
    }
  }

  nextStep(n) {
    var CI = this
    var tab = $('.tab');
    $('#lead-form').parsley().whenValidate({
      group: 'block-' + CI.currentTab
    }).done(function() {
      $(tab[CI.currentTab]).hide();
      CI.currentTab = CI.currentTab+n;
      if (tab.length > 1) {
        $('#prevBtn').show();
      }
      if (CI.currentTab >= tab.length-1) {
        CI.showTab(CI.currentTab)
        if (CI.currentTab >= tab.length-1){
          if (CI.isPhone == true){
            CI.showTab(CI.currentTab)
            CI.postData()
          }
        }else{
          $('#lead-form').parsley().validate()
        }
        return true;
      }
      CI.showTab(CI.currentTab)
    });
  }

  prevStep(n) {
    var tab = $('.tab');
    $(tab[this.currentTab]).hide();
    this.currentTab = this.currentTab + n
    this.showTab(this.currentTab)
  }

  postData(){
    var data = this.getData();
    this.submitLead(data);
    this.successUrl();
  }

  getData() {
    var adType = $( "#ad-type option:selected" ).val();
      return {
      firstname: this.getUrlParameter('firstname') || $(".first_name").val() || '',
      lastname: this.getUrlParameter('lastname') || $(".last_name").val() || '',
      email: this.getUrlParameter('email') || $(".email").val() || '',
      phone1: this.getUrlParameter('phone1') || $(".phone").val() || '',
      companyname: this.getUrlParameter('company-name') || $(".company").val() || '',
      description: this.getUrlParameter('description') || $(".description").val() || '',
      source: this.getUrlParameter('source') || "",
      optindate: this.getFormattedCurrentDate(),
      optinurl: 'https://fpvstudios.com/lead-generation',
      adtype: adType,
    };
  }

  getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  }

  submitLead(formData){
    let insertData = 'mutation ($myItemName: String!, $columnVals: JSON!) { create_item (board_id:1005873737, item_name:$myItemName, column_values:$columnVals) { id } }';
    let vars = {
      "myItemName" : formData.firstname +" "+ formData.lastname,
      "columnVals" : JSON.stringify({
        "email9" : {"email": formData.email,"text": formData.email},
        "service_required6" : formData.adtype,
        "company_name7" : formData.companyname,
        "phone_number7" : formData.phone1,
        "description4" : formData.description,
        "opt_in_url" : `https://fpvstudios.com/${window.location.pathname.split("/").join("")}`,
        "campaign_name" : formData.source
      })
    };
    fetch ("https://api.monday.com/v2", {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Authorization' : 'eyJhbGciOiJIUzI1NiJ9.eyJ0aWQiOjEyMzIxMTA2OSwidWlkIjoxODk5NTUxMSwiaWFkIjoiMjAyMS0wOS0wM1QwNDo1NTowNi44NjRaIiwicGVyIjoibWU6d3JpdGUiLCJhY3RpZCI6ODA0NjI2OSwicmduIjoidXNlMSJ9.mti0VCA0e3PayFgZWDCuyizWeTqVjeFkqZ_uhRBJ3zI'
        },
        body: JSON.stringify({
            'query' : insertData,
            'variables' : JSON.stringify(vars)
        })
    })
    .then(res => res.json())
    .then(res => console.log(JSON.stringify(res, null, 2)));
  }

  getFormattedCurrentDate() {
    var date = new Date();
    var day = this.addZero(date.getDate());
    var monthIndex = this.addZero(date.getMonth() + 1);
    var year = date.getFullYear();
    var min = this.addZero(date.getMinutes());
    var hr = this.addZero(date.getHours());
    var ss = this.addZero(date.getSeconds());

    return day + '/' + monthIndex + '/' + year + ' ' + hr + ':' + min + ':' + ss;
  }

  addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  successUrl(){
    setTimeout(function(){
     window.location = "/success"
    }, 1000)
  }
}

export default Common;
